export default __webpack_public_path__ + "static/media/logo-ul-white.4b086eb7.png";